export default __webpack_public_path__ + "static/media/462702969e30eb5991c85d5133177525.svg";